import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { UtilityLayoutComponent } from '../layout/utility-layout/utility-layout.component';
import { SsoDomainManagementComponent } from '../../features/utility-apps/sso-domain-management/sso-domain-management.component';

export class UtilityRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Only store the SSO Domain component, not the layout
    return this.isSsoDomainManagement(route);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // Only store if there's  a valid handle (non-null)
    if (handle) {
      const key = this.getRouteKey(route);
      this.storedRoutes.set(key, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getRouteKey(route);
    return this.isSsoDomainManagement(route) && this.storedRoutes.has(key);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getRouteKey(route);
    return this.storedRoutes.get(key) || null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // For SSO Domain Management, use custom logic
    if (this.isSsoDomainManagement(future) && this.isSsoDomainManagement(curr)) {
      return true;
    }
    
    // For other routes, use Angular's default behavior
    return future.routeConfig === curr.routeConfig;
  }

  private getRouteKey(route: ActivatedRouteSnapshot): string {
    // Create a specific key for SSO Domain Management
    if (this.isSsoDomainManagement(route)) {
      return 'sso-domain:' + (route.routeConfig?.path || '');
    }
    
    return '';
  }

  private isSsoDomainManagement(route: ActivatedRouteSnapshot): boolean {
    return route.component === SsoDomainManagementComponent;
  }
}